// Single source of truth for "is Google sign-in usable in this build?".
//
// Kept separate from firebase.js so the auth screens can decide whether to show
// the Google button without pulling the Firebase SDK into the main bundle.
export const isGoogleAuthConfigured = Boolean(
  process.env.REACT_APP_FIREBASE_API_KEY &&
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN &&
    process.env.REACT_APP_FIREBASE_PROJECT_ID
);
